import React, { useState, useContext } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { useOktaAuth } from '@okta/okta-react';
import '../../assets/css/Search.css';
import { pickerActivity } from '../../types/userActivity';
import Moment from 'moment';
import ImageDataContext from '../../providers/imageData-context';
import TooltipContentOnDemand from './TooltipContentOnDemand';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Collapse, OverlayTrigger, Popover } from 'react-bootstrap';

export interface Props {}

export const ActivityHistory: React.FC<Props> = (props) => {
    const { oktaAuth, authState } = useOktaAuth();

    const [error, setError] = useState<AxiosError>();
    const [isError, setIsError] = useState(false);

    const imageDataCtx = useContext(ImageDataContext);

    let uid: string = '';
    let cid: string = '';
    let accessToken: string = '';
    let groupName: string = '';
    let userEmail: string = '';
    let checkedFile: pickerActivity[];

    if (!authState) {
        return <div></div>;
    }

    if (authState.isAuthenticated) {
        userEmail = authState.accessToken.claims?.sub;
        uid = authState.accessToken.claims?.uid;
        cid = authState.accessToken.claims?.cid;
        accessToken = authState.accessToken.accessToken;
    }

    const renderContent = imageDataCtx.activityHistory?.map((data, i) => {
        let locationAndType = data.displayAs ?? '';
        let otherInfo = '';
        if (data.displayAs !== null) {
            let descSplit = data.displayAs.split(' ');
            if (descSplit.length > 3) {
                let descMainInfo = descSplit.splice(0, 3);
                locationAndType = descMainInfo.join(' ');
                otherInfo = descSplit.join(' ');
            }
        }

        return (
            <tr key={`keyHistory-${data.name}-${i}`}>
                <OverlayTrigger
                    key={`keyHistoryData-${i}`}
                    placement='auto'
                    delay={{ show: 1000, hide: 0 }}
                    trigger={['hover', 'focus']}
                    rootClose={true}
                    overlay={
                        <Popover
                            id={`tooltiphistory-${data.name}`}
                            className='image-info-popup'
                            key={`tooltiphistory-${data.name}=${
                                imageDataCtx.cachedImageDetails.some((x) => x.name === data.name)
                                    ? 1
                                    : 2
                            }`}
                            title='Image Info'
                        >
                            <Popover.Header as='h3'>Image Info</Popover.Header>
                            <Popover.Body>
                                <TooltipContentOnDemand
                                    fileName={data.name}
                                    large={false}
                                ></TooltipContentOnDemand>
                            </Popover.Body>
                        </Popover>
                    }
                >
                    <td
                        onClick={(e) => imageDataCtx.setLoadedImage(data.name, false)}
                        className={
                            !imageDataCtx.loadedImageFromImageList &&
                            imageDataCtx.loadedImageDetails &&
                            imageDataCtx.loadedImageDetails.name === data.name
                                ? 'section-table tableSelected'
                                : 'section-table'
                        }
                    >
                        <div className='locationInfo'>{locationAndType}</div>
                        <div className='otherInfo'>{otherInfo}</div>
                        <div className='otherInfo otherInfoDate'>
                            {Moment(data.fileAccessDate).format('YYYY-MM-DD')}
                        </div>
                    </td>
                </OverlayTrigger>
            </tr>
        );
    });

    const removeAll = () => {
        imageDataCtx.clearActivityHistory();
    };

    return (
        <>
            {imageDataCtx.activityHistory !== undefined &&
                imageDataCtx.activityHistory.length > 0 && (
                    <div className='row'>
                        <div className='col text-start checkAll'>&nbsp;</div>
                        <div className='col' style={{ maxWidth: '40px', paddingBottom: '10px' }}>
                            <FontAwesomeIcon
                                style={{ cursor: 'hand' }}
                                icon={faTrash}
                                className='menuIcon'
                                title='Remove All'
                                onClick={() => removeAll()}
                            />
                        </div>
                    </div>
                )}
            <div className='row'>
                <Collapse in={true}>
                    <table key='table-vault-history' className='table activityHistoryTable'>
                        <tbody>{renderContent}</tbody>
                    </table>
                </Collapse>
            </div>
        </>
    );
};

export default ActivityHistory;
